import { apiClient } from '@features/shared/api/client'
import type { SidebarHiddenResponse } from './contracts'

const HIDDEN_PATH = '/users/me/sidebar/hidden'

/** GET /users/me/sidebar/hidden: the pages the user keeps out of the sidebar's menus. */
export async function getHiddenPages(): Promise<SidebarHiddenResponse> {
  const { data } = await apiClient.get<SidebarHiddenResponse>(HIDDEN_PATH)
  return data
}

/** POST /users/me/sidebar/hidden: hides a page (a favorite loses its heart). */
export async function hidePage(path: string): Promise<SidebarHiddenResponse> {
  const { data } = await apiClient.post<SidebarHiddenResponse>(HIDDEN_PATH, { path })
  return data
}

/** DELETE /users/me/sidebar/hidden?path=: shows a hidden page again. */
export async function unhidePage(path: string): Promise<SidebarHiddenResponse> {
  const { data } = await apiClient.delete<SidebarHiddenResponse>(HIDDEN_PATH, {
    params: { path },
  })
  return data
}
